import React, { useState, useEffect, useRef } from 'react';
import './ChatApp.css';
import io from 'socket.io-client';
import { toast } from 'react-toastify';
import { Rings } from 'react-loader-spinner';

const { REACT_APP_SocketUrl } = process.env;
console.log("🚀 ~ file: ChatApp.jsx:8 ~ REACT_APP_SocketUrl:", REACT_APP_SocketUrl)

function ChatApp({ patient, updatePatient, wellnessCoach, activeProject}) {
  const [messages, setMessages] = useState([]);
  const [createdDates, setCreatedDates] = useState([]);
  const displayedDates = new Set();
  const [newMessage, setNewMessage] = useState('');
  const socket = useRef(null);
  const bottomRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [recievedMessages, setRecievedMessages] = useState([]);

  useEffect(() => {
    const sortedMessages = patient?.messages.sort((a, b) => a.Id - b.Id);
    setRecievedMessages(sortedMessages);
    const fetchUserId = async () => {
      const idToken = sessionStorage.getItem('idToken');

      const headervalue = `Bearer ${idToken}`;
      try {
        socket.current = io.connect(`${REACT_APP_SocketUrl}`, {
          extraHeaders: {
            Authorization: headervalue,
          },
          path: '/research-application-solutions-senyohealthservice/socket.io',
          transports: ['polling'],
          secure: true,
        });
      } catch (error) {
        console.log(error);
      }

      socket.current.on('message', (obj) => {
        console.log("🚀 ~ file: ChatApp.jsx:36 ~ socket.current.on ~ obj:", obj)
        updatePatient(obj, patient, obj?.CreatedBy, true);
        scrollToBottom(); // Scroll to bottom on new message
      });
      socket.current.on('connect', function () {
        console.log('connected', socket.current.connected);
      });
      socket.current.on('disconnect', function () {
        console.log('disconnected', socket.current.disconnected);
      });
    };
    fetchUserId();
  }, [patient]);

  useEffect(() => {
    setNewMessage('');
    scrollToBottom(); // Scroll to bottom on new received messages
  }, [recievedMessages]);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const sendMessage = (activityObject, messageObject) => {
    setLoading(true);
    socket.current.emit('message', activityObject, (response) => {
      setLoading(false);
      console.log("🚀 ~ file: ChatApp.jsx:54 ~ socket.current.emit ~ response:", response)
      if (response.status === 'fail') {
        toast.error(response.status);
      } else if (response.status === 'success') {
        if (messageObject != null) {
          activityObject.UserActivityMapping = { Activity: {} };
          activityObject.UserActivityMapping.Activity = messageObject.Activity;
        }
        updatePatient(activityObject, patient, wellnessCoach.Id, false);



        setNewMessage('');
        setTimeout(() => {
          scrollToBottom();
        }, 500);
         // Scroll to bottom on sent message
      }
    });
  };

  const sendTextMessage = () => {
    if (newMessage != null) {
      const messageObject = {
        Id: patient.Id,
        Body: newMessage,
        DateCreated: new Date().toISOString(),
        ProjectId: activeProject?.Id
      };
        sendMessage(messageObject, null);
    }
  };

  const onDrop = (evt) => {
    const drop = JSON.parse(evt.dataTransfer.getData('selected'));
    const activityObject = {
      Id: patient.Id,
      Body: null,
      UserActivityId: drop.Id,
      DateCreated: new Date().toISOString(),
      DateModified: new Date().toISOString(),
      DateDestroyed: null,
      ProjectId: activeProject?.Id
    };
    sendMessage(activityObject, drop);
  };
  const formatDate = (date) => {
 
    return (new Date().toLocaleDateString() ===
      new Date(date).toLocaleDateString() &&
      'Today') ||
      new Date(date).getFullYear() +
      '-' +
    ("0"+(new Date(date).getMonth() + 1)).slice(-2) +
      '-' +
    ("0"+(new Date(date).getDate())).slice(-2)
  };

  const onDragOver = (evt) => {
    evt.preventDefault();
  };

  //Styles
  const wellnessCoachMessage = {
    marginLeft: '40%',
    marginRight: '1%',
    marginTop: '1.25%',
    marginBottom: '1.25%',
  };

  const patientCoachMessage = {
    marginLeft: '1%',
    marginRight: '40%',

    marginTop: '1.25%',
    marginBottom: '1.25%',
  };
  const wellnessCoachBubble = {
    backgroundColor: '#F1F9F4',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
    borderBottomLeftRadius: '15px',

    padding: '0.5% 0.5% 0.5% 2%',
  };

  const patientBubble = {
    backgroundColor: '#647ACA',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
    borderBottomRightRadius: '15px',
    padding: '0.5% 0.5% 0.5% 2%',
    color: 'white',
  };

  return (
    <div className = "chatContainer">
      <div className = "messageContainer" onDrop={onDrop} onDragOver={onDragOver}>
        
          <div className='message-area'>
            {recievedMessages.map((message) => {
              const messageDate = new Date(message.DateCreated).toLocaleDateString();
              const showDate = !displayedDates.has(messageDate);
                  if(showDate){
                displayedDates.add(messageDate);
              }
              return (
                
                <div
                  style={
                    message.CreatedBy === patient.Id
                      ? patientCoachMessage
                      : wellnessCoachMessage
                  }
                  key={message.Id}
                >
                  { showDate && (
                    <div
                      style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        margin: '10px 0',
                        color: 'grey',
                      }}
                    >
                      {formatDate(message.DateCreated)}
                    </div>
                  )}
                  <div className=''>
                    <div
                      style={
                        message.CreatedBy === patient.Id
                          ? patientBubble
                          : wellnessCoachBubble
                      }
                      className='col'
                    >
                      {/* SENDER NAME HEADER */}
                      {message.CreatedBy != patient.Id && (
                        <div className="sender-header">
                          {message.sender 
                            ? `${message.sender.FirstName} ${message.sender.LastName}` 
                            : `${wellnessCoach?.FirstName} ${wellnessCoach?.LastName}`}
                        </div>
                      )}
                      <div>
                        <div style={{ padding: '5%' }}>
                          {message.Body === null ? (
                            <div>
                              <h6>
                                {message?.UserActivityMapping?.Activity?.Title}
                              </h6>
                              <hr />
                              <p>
                                {
                                  message?.UserActivityMapping?.Activity
                                    ?.ShortDescription
                                }
                              </p>
                            </div>
                          ) : (
                            <>{message.Body}</>
                          )}
                        </div>
                        {message.Id === patient.Id && (
                          <div className='col-1' style={{ position: 'relative' }}>
                            <div style={{ height: '90%' }}>
                              <></>
                            </div>
                          </div>
                        )}
                        <div
                          className='row'
                          style={{
                            marginLeft: '80%',
                            fontSize: '75%',
                            color: message.CreatedBy === patient.Id ? 'white' : 'black',
                          }}
                        >
                          <div>
                            {new Date(message.DateCreated).toLocaleString('en-US', {
                              hour12: true,
                              hour: 'numeric',
                              minute: 'numeric',
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div ref={bottomRef} />
          </div>
        <div className='text-area'>
          <textarea
          disabled={loading}
            className='form-control'
            id='exampleFormControlTextarea1'
            rows='3'
            placeholder='Type Something'
            value={newMessage}
            onChange={(e) => {
              setNewMessage(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                sendTextMessage();
                setNewMessage('');
              }
            }}
          ></textarea>
        </div>
      </div>
      <div className = "spinner">
        <Rings visible={loading} color="#00BFFF" height={80} width={80} />
        </div>
    </div>
  );
}

export default ChatApp;